{{ animatedNumber | number }} {{ suffix }}
